/*******************************************************************************
 * @ngdoc  provider
 * @name   csm.books.MakeDeposit.provider:ReceiptsServices
 * @description
 * Provides configuration of Make Deposit services.
 *******************************************************************************/
/* @ngInject */ export function DepositsServiceProvider($injector) {
  this.$get = $injector.invoke(service, this);
  this.httpServiceBase = '/books/deposits/';
  this.httpServices = {
    confirmDeposit: function (id) {
      return this.get('confirmDeposit/{0}'.format(id));
    },
    defaults: function () {
      return this.get('defaults');
    },
    dropDeposit: function (id) {
      return this.get('dropDeposit/{0}'.format(id));
    },
    findDeposits: function (searchOptions) {
      return this.post('findDeposits', searchOptions);
    },
    getAccountLists: function () {
      return this.get('getAccountLists');
    },
    getReceiptList: function (depositDateStamp) {
      return this.get('getReceiptList/{0}'.format(depositDateStamp));
    },
    saveDeposit: function (deposit) {
      return this.post('saveDeposit', deposit);
    },
    getDeposit: function (id, dir) {
      return this.get('getDeposit/{0}/{1}'.format(id, dir));
    }
  };
};

/*******************************************************************************
 * service */
/**
 * @ngdoc       service
 * @name        csm.books.MakeDeposit.service:DepositsService
 * @description Make Deposit services.
 *******************************************************************************/
/* @ngInject */ function service() {
return function (HTTPService) {
  return Object.assign(
    HTTPService.make(this.httpServiceBase),
    this.httpServices
  );
};
}
